"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import { persistAcquisitionInBrowser } from "@/lib/acquisition";
import {
  consumeAdsRegistrationConversionCookie,
  fireGoogleAdsRegistrationConversion,
} from "@/lib/ga";

/**
 * Always-on first-touch capture + one-time Google Ads registration conversion
 * (for Google OAuth new-user cookie). Independent of the GA4 snippet so
 * attribution still persists if the measurement ID is unset on a given route.
 */
export function AttributionCapture() {
  const pathname = usePathname();

  useEffect(() => {
    persistAcquisitionInBrowser();
  }, [pathname]);

  useEffect(() => {
    const adsUserId = consumeAdsRegistrationConversionCookie();
    if (adsUserId) fireGoogleAdsRegistrationConversion(adsUserId);
  }, []);

  return null;
}
